import { useReveal } from "@/hooks/useReveal";

const AMB_IMAGES = [
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_talent-ikra/artifacts/f462nojc_male.jpeg",
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_talent-ikra/artifacts/wuaatft7_female.jpeg",
];

export default function BrandAmbassador() {
  const ref = useReveal();
  return (
    <section
      id="ambasador"
      data-testid="ambassador-section"
      className="relative py-24 lg:py-36 bg-[var(--ikra-bg)] border-t border-[var(--ikra-line)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div ref={ref} className="reveal max-w-3xl">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--ikra-gold)] flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[var(--ikra-gold-bright)]" />
            Rola
          </div>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[var(--ikra-ink)] uppercase">
            Bycie{" "}
            <span className="text-[var(--ikra-gold)]">ambasadorem marki</span>.
          </h2>
          <p className="mt-8 text-lg text-[var(--ikra-muted)] leading-relaxed">
            Ambasador marki to twarz brandów, z którymi pracujemy. Rozmawiasz
            z ludźmi na żywo, wnosisz energię do każdego kontaktu i rozwijasz
            się dzięki wsparciu zespołu i praktyce.
          </p>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-7">
          {AMB_IMAGES.map((src, i) => (
            <Tile key={i} src={src} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Tile({ src, i }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`ambassador-image-${i}`}
      className="reveal group relative overflow-hidden rounded-2xl border border-[var(--ikra-line)] aspect-[4/3] bg-[var(--ikra-bg-alt)]"
      style={{ animationDelay: `${i * 100}ms` }}
    >
      <img
        src={src}
        alt=""
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
    </div>
  );
}
